<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="prefix + title">
      <ModuloList @onselect="usuarioModuloSelect" />
    </b-modal>

    <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
    :showClear="!disabled"
      @handleClean="usuarioModuloSelect" invalidFeedback="Módulo deve ser informado!" description=" " :disabled="disabled">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed v-if="!disabled">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import ModuloList from "@/modules/gerenciamento/modulo/ModuloList.vue";

export default {
  components: { LgFormInputFinder, ModuloList },

  props: {
    id: String,
    onselect: Function,
    unidadeAdministrativa: Object,
    value: Object,
    prefix: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: "Módulo",
    },
    label: {
      type: String,
      default: "Módulo:",
    }

  },

  data() {
    return {
      localValue: this.value,
      fields: [
        {
          key: "action",
          label: " ",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center col-1",
        },
        {
          key: "perfil",
          label: "Nome",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center col-1",
        },

      ],
    };
  },

  methods: {
    async show() {
      await this.$refs.finder.show();
    },
    async showModulo() {
      await this.$refs.finderModulo.show();
    },

    async usuarioModuloSelect(item) {
      this.localValue = item;
      this.$emit("onselect", item);
      await this.$bvModal.hide(this.id);

    },

  },
};
</script>